import { Box, styled } from '@mui/material';
import { PrimaryDialog } from 'components/Ui-V3/Dialog';
import WelcomeImage from 'images/authentication/welcome.png';
import { useState } from 'react';
import { ProfileDataSave, ProfileFormData } from './ProfileDataSave';
import { VerifyPhone } from './VerifyPhone';

const FIRST_STEP = 0;

const Container = styled(Box)({
    boxSizing: 'border-box',
    display: 'flex',
    width: '100%',
    height: '100%',
    position: 'relative',
});

const LeftContainer = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 664,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 800,
    minHeight: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
        minWidth: 'unset',
    },
    position: 'relative',
}));

const RightContainer = styled(Box)(({ theme }) => ({
    flex: 1,
    backgroundImage: `url(${WelcomeImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'none',
    [theme.breakpoints.up('md')]: {
        display: 'block',
    },
}));

const CenterSection = styled(Box)(({ theme }) => ({
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    width: '492px',
    padding: theme.spacing(8, 2, 8, 2),
    boxSizing: 'border-box',
}));

type ProfileSetupProps = {
    open: boolean;
    onSuccess: () => void;
};

export function ProfileSetup(props: ProfileSetupProps) {
    const { open, onSuccess } = props;

    const [currentStep, setCurrentStep] = useState(FIRST_STEP);
    const [formData, setFormData] = useState<ProfileFormData | null>(null);

    function onContinue() {
        if (currentStep < formSteps.length - 1) {
            setCurrentStep(step => step + 1);
        } else {
            onSuccess();
        }
    }

    function onGoBack() {
        setCurrentStep(FIRST_STEP);
    }

    function onProfileDataSave(data: ProfileFormData) {
        setFormData(data);
        onContinue();
    }

    const formSteps = [
        <ProfileDataSave onContinue={onProfileDataSave} />,
        <VerifyPhone formData={formData} onSuccess={onContinue} onGoBack={onGoBack} />,
    ];

    return (
        <PrimaryDialog open={open} fullScreen transitionDuration={{ enter: 500, exit: 500 }}>
            <Container>
                <LeftContainer>
                    <CenterSection>{formSteps[currentStep]}</CenterSection>
                </LeftContainer>
                <RightContainer />
            </Container>
        </PrimaryDialog>
    );
}
